import TsParticles, { initParticlesEngine } from '@tsparticles/react'
import { useEffect, useState } from 'react'

import { loadFull } from 'tsparticles'

const ParticlesBackground = () => {
  const [init, setInit] = useState(false)

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadFull(engine)
    }).then(() => {
      setInit(true)
    })
  }, [])

  return (
    <>
      {init && (
        <TsParticles
          id="tsparticles"
          options={{
            fullScreen: { enable: true, zIndex: -1 },
            size: 'cover',
            fpsLimit: 60,
            background: {
              image: 'radial-gradient(#28344B, #0E1012)',
            },
            interactivity: {
              detectsOn: 'window',
              events: {
                onHover: {
                  enable: true,
                  //mode: "grab",
                  parallax: {
                    enable: true,
                    force: 45,
                    smooth: 10,
                  },
                },
              },
            },
            particles: {
              color: { value: '#0098CB' },
              move: {
                direction: 'none',
                enable: true,
                outModes: 'none',
                random: true,
                speed: 0.6,
                straight: false,
              },
              number: {
                density: {
                  enable: true,
                  area: 800,
                },
                value: 200,
              },
              opacity: {
                value: {
                  min: 0.1,
                  max: 0.9,
                },
                animation: {
                  enable: true,
                  speed: 0.4,
                  sync: false,
                  count: 0,
                  random: true,
                },
              },
              shape: {
                type: 'circle',
              },
              size: {
                value: { min: 1, max: 16 },
              },
            },
            emitters: [
              {
                rate: {
                  quantity: 6,
                  delay: 0.2,
                },
                size: {
                  width: 150,
                  height: 0,
                },
                spawnColor: {
                  value: '#84e0f5',
                },
                particles: {
                  size: {
                    value: { min: 1, max: 4 },
                    animation: {
                      enable: true,
                      random: true,
                      speed: 2,
                      sync: false,
                      count: 0,
                      destroy: 'none',
                      mode: 'auto',
                    },
                  },
                },
                move: {
                  speed: 20,
                },
                life: {
                  duration: 8,
                  delay: 2,
                  count: 1,
                },
              },
              {
                rate: {
                  quantity: 6,
                  delay: 3,
                },
                size: {
                  width: 800,
                  height: 800,
                },
                spawnColor: {
                  value: '#0098CB',
                },
                particles: {
                  size: {
                    value: { min: 88, max: 224 },
                    animation: {
                      enable: true,
                      random: true,
                      speed: 2,
                      sync: false,
                      count: 0,
                      destroy: 'none',
                      mode: 'auto',
                    },
                  },
                  opacity: {
                    value: 0.1,
                  },
                },
                life: {
                  duration: 8,
                  delay: 2,
                  count: 1,
                },
              },
              {
                rate: {
                  quantity: 2,
                  delay: 1,
                },
                size: {
                  width: 200,
                  height: 0,
                },
                spawnColor: {
                  value: '#0098CB',
                },
                particles: {
                  size: {
                    value: { min: 0.2, max: 12 },
                  },
                },
                move: {
                  speed: 20,
                },
                life: {
                  duration: 8,
                  delay: 2,
                  count: 1,
                },
              },
            ],
          }}
        />
      )}
    </>
  )
}

export default ParticlesBackground
